import React, { Component } from 'react';

export default class Terms extends Component {
  render() {
    return (
      <div>
        {/* Page Title */}
        <section className="page-title bg-1">
          <div className="overlay"></div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="block text-center">
                  <span className="text-white">Please Read Carefully</span>
                  <h1 className="text-capitalize mb-5 text-lg">Terms & Conditions</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Terms Content */}
        <section className="section terms-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                {termsData.map((item, index) => (
                  <div key={index} className="mb-5">
                    <h5 className="font-weight-bold">{item.title}</h5>
                    <p className="text-muted">{item.description}</p>
                    <hr />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

// Terms content
const termsData = [
  {
    title: '1. Eligibility',
    description: 'You must be at least 18 years old and a member of the Brahmin community to register on Varenya Matrimonial.'
  },
  {
    title: '2. Profile Authenticity',
    description: 'Users must provide accurate and truthful information. Misleading profiles may be removed without notice.'
  },
  {
    title: '3. Account Responsibility',
    description: 'You are responsible for safeguarding your account credentials. We are not liable for unauthorized access.'
  },
  {
    title: '4. Privacy Policy',
    description: 'Your data is handled according to our privacy practices. Refer to our Privacy Policy for more details.'
  },
  {
    title: '5. Termination',
    description: 'We reserve the right to terminate accounts that violate our terms or show inappropriate behavior.'
  },
  {
    title: '6. Payment Terms',
    description: 'Membership fees are non-refundable once paid. Pricing may change with notice to users.'
  },
  {
    title: '7. Platform Liability',
    description: 'Varenya Matrimonial does not guarantee successful matches or engagements and is not liable for user interactions.'
  },
  {
    title: '8. Changes to Terms',
    description: 'These terms may be updated occasionally. Continued use of the platform indicates acceptance of any changes.'
  },
  {
    title: '9. Support',
    description: 'For any queries, reach us at info@varenyamatrimonial.com or call +91-8105626363.'
  }
];
